import { Button, Container, MenuItem, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { getRoles, getUnRegisteredStaffs } from "../services/get.service";
import { staff, role } from "../common/type";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { user } from "../validations/Validation";
import { toast } from "react-toastify";
import { postUser } from "../services/post.service";
import { useNavigate } from "react-router-dom";

interface UserForm {
    staffId: number;
    roleId: number;
    email: string;
    password: string;
    confirmPassword: string;
    phoneNumber: string;
}

const Register = () => {
    const [staffs, setStaffs] = useState<staff[]>([])
    const [roles, setRoles] = useState<role[]>([])
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        getUnRegisteredStaffs()
            .then((res) => setStaffs(res.data))
            .catch((err) => console.log(err))

        getRoles()
            .then((res) => setRoles(res.data))
            .catch((err) => console.log(err))
    }, [])

    const { register, handleSubmit, formState: { errors } } = useForm<UserForm>({
        resolver: yupResolver(user)
    })

    const onSubmit = (data: any) => {
        setLoading(true)
        const loading = toast.loading("Please wait...", {
            theme: "colored",
            type: "info",
            closeButton: true,
        })

        postUser(data)
            .then((res) => {
                toast.update(loading, {
                    render: res.data,
                    type: "success",
                    theme: "colored",
                    autoClose: 2500,
                    isLoading: false,
                    closeOnClick: true,
                    hideProgressBar: false,
                });
                setLoading(false);
                navigate("/");
            })
            .catch((err) => {
                toast.update(loading, {
                    render: err?.response?.data || "Some Error happened",
                    theme: "colored",
                    autoClose: 5000,
                    type: "error",
                    isLoading: false,
                    closeOnClick: true,
                    hideProgressBar: false,
                });
                setLoading(false);
                console.log(err);
            })
    }

    return <>
        <Helmet>
            <title>Register</title>
        </Helmet>
        <Container className="bg-amber50 m-4 lg:m-12">
            <Typography className="pt-6 text-xl font-bold" variant="h5" align="center">Register User</Typography>
            <div className="p-10 px-3 lg:px-44">
                <form className="grid gap-3" onSubmit={handleSubmit(onSubmit)}>
                    <div>
                        <TextField size="small" fullWidth label="Select Staff" select {...register("staffId")} error={errors.staffId ? true : false}>
                            {staffs.map((staff) => (
                                <MenuItem value={staff.id}>{staff.firstName + ' ' + staff.middleName + ' ' + staff.lastName}</MenuItem>
                            ))}
                        </TextField>
                        <p color="error" className="text-red-700 text-sm">{errors.staffId?.message}</p>
                    </div>
                    <div>
                        <TextField size="small" fullWidth label="Select Role" select {...register("roleId")} error={errors.roleId ? true : false}>
                            {roles.map((role) => (
                                <MenuItem value={role.id}>{role.name}</MenuItem>
                            ))}
                        </TextField>
                        <p color="error" className="text-red-700 text-sm">{errors.roleId?.message}</p>
                    </div>
                    <div>
                        <TextField size="small" fullWidth label="Email" type="email" {...register("email")} error={errors.email ? true : false} />
                        <p color="error" className="text-red-700 text-sm">{errors.email?.message}</p>
                    </div>
                    <div>
                        <TextField size="small" fullWidth label="Phone Number" {...register("phoneNumber")} error={errors.phoneNumber ? true : false} />
                        <p color="error" className="text-red-700 text-sm">{errors.phoneNumber?.message}</p>
                    </div>
                    <div>
                        <TextField size="small" fullWidth label="Password" type="password" {...register("password")} error={errors.password ? true : false} />
                        <p color="error" className="text-red-700 text-sm">{errors.password?.message}</p>
                    </div>
                    <div>
                        <TextField size="small" fullWidth label="Confirm Password" type="password" {...register("confirmPassword")}
                            error={errors.confirmPassword ? true : false} />
                        <p color="error" className="text-red-700 text-sm">{errors.confirmPassword?.message}</p>
                    </div>
                    <Button variant="contained" disabled={loading} type="submit" fullWidth>Submit</Button>
                </form>
            </div>
        </Container>
    </>;
};

export default Register;
